<template>
  <div class="footer-container">
    <InsuranceCardFooter
      :packages="packages"
      @cardExpanded="cardExpanded"
      :testator="testator"
      @updateInsurance="params => $emit('updateInsurance', params)"
    />
  </div>
</template>

<script>
  import InsuranceCardFooter from '../insurance/InsuranceCardFooter.vue';
  export default {
    name: 'ProductPackageVerticalContent',
    components: {
      InsuranceCardFooter,
    },
    props: {
      packages: {
        required: true,
        type: Array,
      },
      testator: {
        required: true,
        type: Object,
      },
    },
    methods: {
      cardExpanded() {
        this.$emit('cardExpanded');
      },
    },
  };
</script>
<style lang="scss" scoped>
  .footer-container {
    height: 100%;
  }
</style>
